import React, { useEffect, useRef } from 'react';
import { logoutUser } from '../components/Api';
import { useNavigate } from 'react-router-dom';
import { Link } from "react-router-dom";
import Imagepng from '../components/Image_png';

const Logout = ({ setIsAniActive2, setIsAniActive3, setIsAniActive4 }) => {
  const navigate = useNavigate();
  const logoutButtonRef = useRef(null);

  const handleLogout = async () => {
    const token = localStorage.getItem('token');
    if (token) {
      try {
        await logoutUser(token);
        localStorage.removeItem('token');
        localStorage.removeItem('user');
        localStorage.removeItem('userId');
        localStorage.removeItem('userData');
        navigate('/login');

        // After logout, reset all active states to remove 'act' class
        setIsAniActive2(false);
        setIsAniActive3(false);
        setIsAniActive4(false);
      } catch (error) {
        console.error('Error logging out:', error);
      }
    }
  };

  useEffect(() => {
    const timeoutId = setTimeout(() => {
      if (logoutButtonRef.current) {
        logoutButtonRef.current.click(); // Automatically click the button
      }
    }, 10 * 60 * 1000); // 60 seconds

    return () => clearTimeout(timeoutId); // Cleanup the timeout on unmount
  }, []); // Empty dependency array ensures this runs only once

  return (
    <li>
      <Link ref={logoutButtonRef} onClick={handleLogout}>
        <Imagepng text={'dbl12'} />
        Log Out
      </Link>
    </li>
  );
};

export default Logout;
